import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/guanhuai/bscClueZhaobiao',


    // 删除
    deleteById(query){
        return http({
            url: this.baseurl+'/deleteById?id=' + query,
            method: 'post',
            //data: query
        });
    },


    //指派
    designate(query){
        return http({
            url: this.baseurl+'/designate',
            method: 'post',
            data: query
        });
    },


    //联系人修改查询单个
    selectById(query){
        return http({
            url: this.baseurl+'/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },


    //线索管理查询
    selectPage(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            data: query,
        })
    },
    clueToProject(data){
        return http({
            url: this.baseurl+'/clueToProject',
            method: 'post',
            data: data,
        })
    },

    //获取线索来源
    getClueResource(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/getResourceList',
            method: 'post',
            params: query
        });
    },

    //获取线索来源
    undertake(query){
        return http({
            url: this.baseurl+'/undertake',
            method: 'post',
            params: query
        });
    },


    //查询线索日志
    selectCluePushLog(query){
        return http({
            url: '/api/swyl/bscCluePushLog/getCluePushLogByMainId',
            method: 'post',
            data: query
        })
    },
}
